<template>
  <div id="teacher_info">
    <div class="tea_r">
      <div class="tea_hnav">
        <router-link :to="{ name: 'teacher_basic'}">
          <button type="submit" class="teah_btn">{{showPage.personalInformation}}</button>
        </router-link>
      </div>
      <div class="tea_hnav">
        <router-link :to="{ name: 'teacher_edu'}">
          <button type="submit" class="teah_btn">{{showPage.educationCourses}}</button>
        </router-link>
      </div>
      <div class="tea_hnav">
        <router-link :to="{ name: 'teacher_prize'}">
          <button type="submit" class="teah_btn">{{showPage.awardsExperiences}}</button>
        </router-link>
      </div>
      <!--       <div class="tea_hnav">
        <router-link :to="{ name: 'teacher_seminar'}">
          <button type="submit" class="teah_btn">{{showPage.seminar}}</button>
        </router-link>
      </div>
      <div class="tea_hnav">
        <router-link :to="{ name: 'teacher_journal'}">
          <button type="submit" class="teah_btn">{{showPage.journal}}</button>
        </router-link>
      </div>
      <div class="tea_hnav">
        <router-link :to="{ name: 'teacher_book'}">
          <button type="submit" class="teah_btn">{{showPage.book}}</button>
        </router-link>
      </div>
      <div class="tea_hnav">
        <router-link :to="{ name: 'teacher_research'}">
          <button type="submit" class="teah_btn">{{showPage.research}}</button>
        </router-link>
      </div> -->
      <div class="tea_hnav" v-for="(custom,index) in customs" :key="index">
        <router-link :to="{ name: 'teacher_custom', params: {custom: index}}">
          <button type="submit" class="teah_btn">{{showName(custom)}}</button>
        </router-link>
      </div>
      <div class="fix"></div>
      <!--{{teacherpublications}}-->
      <router-view :teacher="info" :teacherpublications="teacherpublications" :customs="customs"></router-view>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'teacher_info',
  props: ['teacher'],
  data() {
    return {
      teacherId: this.$route.params.teacherid,
      info: {},
      teacherpublications: [],
      customs: [],
      showPage: ShowPage(sessionStorage.getItem('locale')),
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.initInfo();
      this.initPublications();
      this.initCustoms();
    },
    initInfo() {
      if (this.teacher)
        this.info = this.teacher;
      else
        this.getData();
    },
    initPublications() {
      this.getPublicationsData();
    },
    initCustoms() {
      this.getCustomsData();
    },

    getData() {
      axios.get(API.teacher + `?id=${this.teacherId}`)
        .then(response => {
          this.info = response.data;
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    getPublicationsData() {
      axios.get(API.teacherpublication + `?teacherId=${this.teacherId}`)
        .then(response => {
          this.teacherpublications = response.data.filter(data => {
            return data.trash !== 1;
          });
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    getCustomsData() {
      axios.get(API.teacherCustom + `?teacherid=${this.teacherId}`)
        .then(response => {
          this.customs = response.data;
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },



    showName(custom) {
      let name = { 'CH': custom.nameCh, 'EN': custom.nameEn }
      return name[sessionStorage.locale];
    },
  },
}

</script>
<style lang="scss">


</style>



// WEBPACK FOOTER //
// TeacherInfo.vue?aa8a9cf4